// extracted by mini-css-extract-plugin
export default {"trigger":"caption-info_trigger__JEvbr","accent":"caption-info_accent__gMOpn","content":"caption-info_content__Tjlfm"};